import { styled } from "@mui/material/styles";
import { Accordion, AccordionSummary, Button, IconButton, TextField, Typography } from "@mui/material";

import { useColors } from "../../Context/ColorsContext";
import { MediaQuerys } from "../../styles/GlobalStyle";
import { SaveAltRounded } from "@mui/icons-material";

const { mobile, tablet, desktop } =  MediaQuerys;

function buttonType(type) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { colors } = useColors();
    if (type === 'reject') return colors.grayGraphic
    if (type === 'delete') return colors.red
    if (type === 'accept') return colors.green
    return colors.main
}

export const ButtonApprove = styled(Button)(({type, hideBtnCancel}) => {
    const { colors } = useColors();

    return {
        // visibility: hideBtnCancel === undefined && 'hidden',
        margin: '0.8rem 0 0 0',
        width: '100%',
        height: 40,
        background: buttonType(type),
        color: colors.white,
        "&:hover": {
            background: buttonType(type),
            opacity: 0.8
        }
    }
})

export const CustomAccordion = styled(Accordion)(() => {
  	const { colors } = useColors();
    return {
        minHeight: '45px',
        color: '#6e6e6e',
        '& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root': {
            fontSize: '2rem',
        },
        '[aria-expanded="true"]': {
            backgroundColor: '#ebf0f8',
            color: colors.buttonActionColor,
            fontWeight: 600,
        },
        '[aria-expanded="true"] .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root': {
            color: colors.buttonActionColor,
        },
    }
})

export const CustomAccordionSummary = styled(AccordionSummary)(() => {
    return {
    }
})

export const PdfIcon = styled(SaveAltRounded)(() => {
  const { colors } = useColors();
  return {
    fontSize: 31,
    color: colors.buttonActionColor,
    padding: '2px 6px',
    backgroundColor: 'transparent',
    borderRadius: "8px",
    border: `1px solid ${colors.buttonActionColor}`,
    "&:hover": {
      backgroundColor: 'transparent',
      opacity: 0.8,
      cursor: 'pointer'
    },
  }
})

export const CustomTypography = styled('p')(() => {
    return {
        
            fontSize: '14px',
          [tablet]: {
              fontSize: '12px'
          }
      }
})

export const CustomTextField = styled(TextField)(() => {
    return {
        width: '100%',
        '.MuiInputBase-input': {
            [desktop]: {
                fontSize: '0.85rem'
            }
        }
    }
})

export const Title = styled(Typography)(() => {
    const { colors } = useColors();
    return {
        color: colors.grayFont,
        fontSize: '1rem',
        lineHeight: 1.2,
        [desktop]: {
            fontSize: '0.75rem'
        }
    }
})

export const Space = styled('div')(() => {
    return {
        padding: 2
    }
})

export const IconContainer = styled(IconButton)(() => {
    const { colors } = useColors();
    return {
      borderRadius: "8px",
      backgroundColor: colors.background,
      color: colors.buttonActionColor,
      "&:hover": {
        backgroundColor: colors.buttonActionColor,
        opacity: 0.9,
        color: colors.background,
      },
    };
});

export const ContainerIconsRight = styled('div')(() => {
    return {
        display: 'flex',
        width: '20%',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        gap: '1.2rem',
        marginRight: '1.8rem',
        [mobile]: {
            marginRight: '0.40rem',
        }
    }
})

export const Content = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '0.50rem',
        width: '100%',
    }
})

export const ContainerText = styled('div')(() => {
    return {
        width: '80%'
    }
})

